import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=ab7f82a2&scoped=true"
import script from "./awards.vue?vue&type=script&lang=js"
export * from "./awards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7f82a2",
  null
  
)

export default component.exports